var _style, _linearGradient, _path, _path2, _path3, _linearGradient2, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#path2995-1-0_1_)}.st1{fill:#c8daea}.st2{fill:#a9c9dd}.st3{fill:url(#path2991_1_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "path2995-1-0_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -683.305,
    y1: 534.845,
    x2: -693.305,
    y2: 511.512,
    gradientTransform: "matrix(6 0 0 -6 4255 3247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37aee2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e96c8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2995-1-0",
    className: "st0",
    d: "M240 120c0 66.3-53.7 120-120 120S0 186.3 0 120 53.7 0 120 0s120 53.7 120 120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2993",
    className: "st1",
    d: "M98 175c-3.9 0-3.2-1.5-4.6-5.2L82 132.2 152.8 88l8.3 2.2-6.9 18.8L98 175z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2989",
    className: "st2",
    d: "M98 175c3 0 4.3-1.4 6-3 2.6-2.5 36-35 36-35l-20.5-5-19 12-2.5 30v1z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "path2991_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.991,
    y1: 118.245,
    x2: 153.991,
    y2: 78.245,
    gradientTransform: "matrix(1 0 0 -1 0 242)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2991",
    className: "st3",
    d: "M100 144.4l48.4 35.7c5.5 3 9.5 1.5 10.9-5.1L179 82.2c2-8.1-3.1-11.7-8.4-9.3L55 117.5c-7.9 3.2-7.8 7.6-1.4 9.5l29.7 9.3L152 93c3.2-2 6.2-.9 3.8 1.3L100 144.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramBig);
export default __webpack_public_path__ + "static/media/telegram_big.feb915a8db6c4550c841166e4dc1524c.svg";
export { ForwardRef as ReactComponent };